import { NavigateFunction } from 'react-router-dom';

/**
 * Creates a function that will do a `replace` operation on the brower
 * history stack.
 *
 * @param navigate The react router's navigate function.
 */
export function permanentRedirect(navigate: NavigateFunction) {
  /**
   * Redirects to the given path permanently.
   *
   * @param path The path to navigate to.
   */
  return function (path: string) {
    navigate(path, { replace: true });
  };
}

/**
 * Replaces the values in the given `params` object with corresponding keys in the `pathname` string.
 * The replaced values are prefixed with a colon (:) to indicate route parameters.
 *
 * @param params - An object containing key-value pairs representing route parameters.
 * @param pathname - The original pathname string.
 * @returns The modified pathname string with route parameters replaced.
 */
export function recreateRoutePath(params, pathname: string) {
  return Object.keys(params).reduce((pathBuilder, key) => {
    if (key === '*') {
      return pathBuilder;
    }
    return pathBuilder.replace(params[key], `:${key}`);
  }, pathname);
}
